import { getEtiquetaDgtCodeFromFuelType, getFuelTypesForMotorizacion } from '../../../helpers/carline-helpers';
import {
	isCallMeForm,
	isLeadVentaCitaForm,
	isLeadVentaEmpresasForm,
	isLeadVentaMasInformacionForm,
	isLeadVentaPresupuestoForm,
	isLeadVentaStockForm,
	isLeadVentaTestDriveForm,
	isLeadVentaVehiculoOcasionForm,
	isProspectVentaForm,
} from '../../../helpers/form-helpers';
import { CarlineWithSalesgroups } from '../../../types/vehicle-types';
import { externalContentManager } from '../../external-content';

// By form type

export const isCarlineAvailableForCurrentForm = (carline: CarlineWithSalesgroups): boolean => {
	if (isLeadVentaTestDriveForm()) return !!carline.formularios.testDrive;
	if (isLeadVentaPresupuestoForm()) return !!carline.formularios.presupuesto;
	if (isLeadVentaMasInformacionForm()) return !!carline.formularios.masInformacion;
	if (isProspectVentaForm()) return !!carline.formularios.prospect;
	if (isCallMeForm()) return !!carline.formularios.callMe;
	if (isLeadVentaCitaForm()) return !!carline.formularios.cita;
	if (isLeadVentaStockForm()) return !!carline.formularios.stock;
	if (isLeadVentaVehiculoOcasionForm()) return !!carline.formularios.vo;
	if (isLeadVentaEmpresasForm()) return !!carline.formularios.empresas;

	return true;
};

export const filterAvailableCarlinesForCurrentForm = (
	carlines: CarlineWithSalesgroups[],
): CarlineWithSalesgroups[] | null => {
	const availableCarlines = carlines.filter((carline) => isCarlineAvailableForCurrentForm(carline));
	return availableCarlines.length > 0 ? availableCarlines : null;
};

// By motorizacion

export const filterCarlinesByMotorizacion = (carlines: CarlineWithSalesgroups[]): CarlineWithSalesgroups[] | null => {
	// Comprobar que existe la motorización externa antes de filtrar
	const externalMotorizacion = externalContentManager.motorizacion;
	if (!externalMotorizacion) return null;

	const unique = (values: string[]): string[] => values.filter((value, index) => values.indexOf(value) === index);

	// Función para obtener las etiquetas DGT correspondientes a un conjunto de combustibles
	const getEtiquetasDGT = (combustibles: string[]): string[] => {
		const etiquetas: string[] = [];
		for (const combustible of combustibles) {
			const etiqueta = getEtiquetaDgtCodeFromFuelType(combustible);
			if (etiqueta) etiquetas.push(etiqueta);
		}
		return unique(etiquetas);
	};

	const filteredCarlines: CarlineWithSalesgroups[] = [];

	for (const carline of carlines) {
		const salesgroups: CarlineWithSalesgroups['salesgroups'] = [];
		const carlineCombustibles: string[] = [];

		// Filtrar los salesgroups del carline según la motorización
		for (const salesgroup of carline.salesgroups ?? []) {
			const combustibles = getFuelTypesForMotorizacion(salesgroup, externalMotorizacion);
			if (combustibles.length === 0) continue;

			// Reconstruir el salesgroup con los combustibles y etiquetas DGT correspondientes
			salesgroups.push({ ...salesgroup, combustibles, etiquetasDGT: getEtiquetasDGT(combustibles) });
			carlineCombustibles.push(...combustibles);
		}

		if (salesgroups.length === 0) continue;

		const combustibles = unique(carlineCombustibles);
		// Reconstruir el carline con los combustibles y etiquetas DGT correspondientes
		filteredCarlines.push({ ...carline, combustibles, etiquetasDGT: getEtiquetasDGT(combustibles), salesgroups });
	}

	return filteredCarlines.length > 0 ? filteredCarlines : null;
};
